export const routeConfigs = {
  waterFall: { path: 'waterfall' },
  gps: { path: 'gps-redirect/:locationString' },
  auth: {
    path: 'auth',
    login: { path: 'login' },
  },
  adminLogin: { path: 'admin-login' },
  admin: {
    path: 'admin',
    accounts: { path: 'accounts' },
  },
  hub: {
    path: 'hub/:hubName',
    eventCalendar: { path: 'events' },
    similarEventCalendar: { path: 'similar-events/:type' },
    placeCalendar: { path: 'places' },
    similarPlaceCalendar: { path: 'similar-places' },
    editAccount: { path: 'edit' },
    contentManagement: { path: 'content' },
    editEventBriteAccount: { path: 'edit-eventbrite' },
    createEvent: { path: 'create-event' },
    blockKeywords: { path: 'block-keywords' },
    aiSettings: { path: 'ai-settings' },
    customization: { path: 'customization' },
    marketing: { path: 'marketing' },
    uploadEvents: { path: 'upload-events' },
    manuallyAdd: { path: 'manually-add' },
    tours: { path: 'tours' },
    googlePlace: { path: 'google-place' },
  },
  visitor: {
    path: ':hubName',
    eventCalendar: { path: 'events' },
    eventMap: { path: 'events/map' },
    editorChoice: { path: 'events-editor-choice' },
    customEvent: { path: 'custom-events/:customEventBtnId' },
    customPlace: { path: 'custom-places/:customPlaceBtnId' },
    eventDetails: { path: 'events/:eventId' },
    eventDetailsModal: { path: 'event-details/:eventId' },
    placeDetails: { path: 'place/:placeId/:category/:menuType' },
    placeDetailsWithCategory: { path: 'place/:placeId/:category' },
    placeCalendar: { path: 'places/:category/:menuType' },
    placeMap: { path: 'places-map/:category/:menuType' },
    placeEditorChoice: { path: 'places-editor-choice' },
    placeDetailsNotSimple: { path: 'place/:placeId' },
    placeDetailsModal: { path: 'place-details/:placeId' },
    placeCalendarNotSimple: { path: 'places/:category' },
    placeMapNotSimple: { path: 'places-map/:category' },
    createEvent: { path: 'create-event/:isShowSidebar' },
    createPlace: { path: 'create-place' },
  },
  tripPlanner: {
    path: ':hubName',
    trip: { path: 'trips' },
    region: { path: 'region/:regionId' },
    tripShare: { path: 'trips/:tripId' },
    singleTripShare: { path: 'trips/:tripId/:singleTripId' },
    tourShare: { path: 'trips/tour/:tourId' },
    // tourPDF: {path: 'trips/tour/:tourId-pdf'},
    tourPDF: { path: ':pdf/:tourOrTrip/:tourOrTripId/:version' },
    tourList: { path: 'trips/tour-list/' },
  },
  submit: {
    path: '',
    event: { path: ':hubName/submit-event' },
    place: { path: ':hubName/submit-place' },
  },
};

export function getRouteUrl(route: any, parameters?: any): string {
  let routeParameters = [];
  let config = (route.config || []).slice();

  if (parameters) {
    config.forEach((path, index) => {
      if (path.startsWith(':')) {
        routeParameters.push({ path, index });
      }
    });

    for (let parameter of routeParameters) {
      config[parameter.index] = parameters[parameter.path.substr(1, parameter.length)];
    }
  }

  let parentUrl = route.parent ? getRouteUrl(route.parent, parameters) : '';
  let childUrl = config.join('/');

  if (childUrl) {
    parentUrl += '/';
  }

  return `${parentUrl}${childUrl}`;
}

function setRouteConfigRelationship(child: any, parent: any) {
  for (let propName in child) {
    if (propName !== 'path' && child.hasOwnProperty(propName)) {
      setRouteConfigRelationship(child[propName], child);
    }
  }

  child.parent = parent;
  child.config = child.path.split('/');
}

for (let propName in routeConfigs) {
  if (routeConfigs.hasOwnProperty(propName)) {
    setRouteConfigRelationship(routeConfigs[propName], routeConfigs);
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/constants/route.config.ts